"use client";

import { useEffect } from "react";
import { triggerAnalyticsNavLink } from "@marketing-sites/analytics/trigger-analytics-event";
import type { NavItemClickEventDetail } from "@marketing-sites/ui/components";

/**
 * Client component that listens for navigation item clicks
 * from the shared-component library and triggers analytics tracking.
 *
 * This component listens for the "navItemClick" custom event
 * dispatched from navigation components and tracks the interaction
 * via the analytics system.
 */
export function NavItemClickListener() {
  useEffect(() => {
    const handleNavItemClick = (
      event: Event & { detail?: NavItemClickEventDetail },
    ) => {
      if (event.detail) {
        const { detail } = event;

        triggerAnalyticsNavLink(detail);
      }
    };

    window.addEventListener(
      "navItemClick",
      handleNavItemClick as EventListener,
    );

    return () => {
      window.removeEventListener(
        "navItemClick",
        handleNavItemClick as EventListener,
      );
    };
  }, []);

  // This is a client island - no UI rendered
  return null;
}
